import { UserOutlined } from "@ant-design/icons";
import styles from "./index.module.css";
import { Rate } from "antd";
// import { API_ORIGIN } from "helpers/constants";
import chatTeardropText from "assets/svg/ChatTeardropText.svg";
import { API_ORIGIN } from "helpers/constants";
import { formatLastOnline } from "helpers/format";

export function getAvatarSrc(avatar: string): string {
  if (/^(https?:)?\/\//.test(avatar) || avatar.startsWith("data:")) {
    return avatar;
  }
  return API_ORIGIN + "/public/avatars/" + avatar;
}

type Props = {
  el: {
    avatar: string;
    rating: number;
    firstName: string;
    lastName: string;
    isOnlyName?: boolean;
    reviewCount?: number;
    lastOnline?: string;
    online: boolean;
  };
  avatarSize?: number;
};

export const UserNameRatingPhotoComponent = ({ el, avatarSize }: Props) => {
  return el.lastOnline || el.online ? (
    el.rating && !el.online ? (
      <div className={styles.containerV2}>
        <div>
          {el?.avatar ? (
            <img
              src={getAvatarSrc(el.avatar)}
              // src={el.avatar}
              alt="userPhoto"
              width={avatarSize || 46}
              height={avatarSize || 46}
              style={{ borderRadius: "100%" }}
            />
          ) : (
            <div
              style={{
                width: avatarSize || 46,
                height: avatarSize || 46,
                borderRadius: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <UserOutlined size={avatarSize || 46} />
            </div>
          )}
        </div>
        <div className={styles.nameRate}>
          <div>
            <div className={styles.rating}>
              <Rate disabled defaultValue={el.rating} className={styles.rate} style={{ color: "#FFCC4A" }} count={1} />{" "}
              <span>{el.rating.toFixed(1)}</span>
            </div>
            <div className={styles.reviews}>
              <img src={chatTeardropText} alt="chat icon" />
              <div>
                <span>{el.reviewCount}</span> <span>Reviews</span>
              </div>
            </div>
          </div>
          {el.isOnlyName ? (
            <div>{`${el.firstName}`.slice(0, 15)}</div>
          ) : (
            <div>{`${el.firstName} ${el.lastName}`.slice(0, 15)}</div>
          )}
        </div>
      </div>
    ) : (
      <div className={styles.containerV2}>
        <div>
          {el?.avatar ? (
            <img
              src={getAvatarSrc(el.avatar)}
              alt="userPhoto"
              width={avatarSize || 46}
              height={avatarSize || 46}
              style={{ borderRadius: "100%" }}
            />
          ) : (
            <div
              style={{
                width: avatarSize || 46,
                height: avatarSize || 46,
                borderRadius: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <UserOutlined size={avatarSize || 46} />
            </div>
          )}
        </div>
        <div className={styles.nameAndOnline}>
          {el.isOnlyName ? (
            <div>{`${el.firstName}`.slice(0, 15)}</div>
          ) : (
            <div>{`${el.firstName} ${el.lastName}`.slice(0, 15)}</div>
          )}
          <div>
            {el.online ? (
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ lineHeight: "14px" }}>online</span>{" "}
                <div style={{ backgroundColor: "#52c41a", width: 6, height: 6.2, borderRadius: "100%" }}></div>
              </div>
            ) : (
              formatLastOnline(el.lastOnline)
            )}
          </div>
        </div>
      </div>
    )
  ) : (
    <div className={styles.container}>
      <div>
        {el?.avatar ? (
          <img
            src={getAvatarSrc(el.avatar)}
            alt="userPhoto"
            width={avatarSize || 46}
            height={avatarSize || 46}
            style={{ borderRadius: "100%" }}
          />
        ) : (
          <div
            style={{
              width: avatarSize || 46,
              height: avatarSize || 46,
              borderRadius: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <UserOutlined size={avatarSize || 46} />
          </div>
        )}
      </div>
      <div className={styles.nameRate}>
        <div>{el?.rating ? <Rate disabled defaultValue={el.rating} className={styles.rate} /> : "—"}</div>
        {el.isOnlyName ? (
          <div>{`${el.firstName}`.slice(0, 15)}</div>
        ) : (
          <div>{`${el.firstName} ${el.lastName}`.slice(0, 15)}</div>
        )}
      </div>
    </div>
  );
};
